// import { useAuth } from '@clerk/react'
// import { useEffect } from 'react'
// import endpoints from './services/api'
// import { setToken, clearToken } from '././redux/Auth/authSlice'
// import { useDispatch } from 'react-redux'

// const ClerkTokenSetter = () => {
//     const { isLoaded, isSignedIn, getToken } = useAuth()
//      const dispatch = useDispatch()

//     useEffect(() => {
//         const syncToken = async () => {
//             if (!isLoaded) return

//             if (isSignedIn) {
//                 const token = await getToken()
//                 endpoints.setAuthToken(token)
//                 dispatch(setToken(token))      
//             } else {
//                 endpoints.removeAuthToken()    
//                 dispatch(clearToken())   
//             }
//         }

//         syncToken()
//     }, [isLoaded, isSignedIn])

//     return null  
// }

// export default ClerkTokenSetter


// import { useAuth } from '@clerk/clerk-react'
import { useAuth } from '@clerk/react'
import { useEffect, useRef } from 'react'
import { setupApiInterceptors } from './services/api'
import { userSignedIn, userSignedOut } from '././redux/Auth/authSlice'
import { useDispatch } from 'react-redux'

const ClerkTokenSetter = ({ onReady }) => {
    const { isLoaded, isSignedIn, getToken } = useAuth()
    const getTokenRef = useRef(getToken)
    getTokenRef.current = getToken
    const dispatch = useDispatch()

    useEffect(() => {
        if (!isLoaded) return

        const wrappedGetToken = (...args) => getTokenRef.current(...args)
        setupApiInterceptors(wrappedGetToken)

        if (isSignedIn) {
            dispatch(userSignedIn())
        } else {
            dispatch(userSignedOut())
        }

        if (onReady) onReady()

    }, [isLoaded, isSignedIn])

    return null
}

export default ClerkTokenSetter